import { SegmentLinkModel, SegmentTransferModel } from '@/lib/models/segment/types';

import { getIsSegmentTransfer } from '../get-is-segment-transfer';

export const getLinkSegments = (segments: (SegmentLinkModel | SegmentTransferModel)[]): SegmentLinkModel[] => {
  return segments.filter((segment): segment is SegmentLinkModel => !getIsSegmentTransfer(segment));
};
